import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateSkipVerification = {
  skipVerification: { data: null, loading: false, error: null },
};

export const skipVerification = createAsyncThunk('user/skipVerification', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(
      `${process.env.REACT_APP_SERVER_API}/vacancies/${data.id}/skip-verification`,
      {
        skip_verification: data.skip_verification,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerSkipVerification = {
  [skipVerification.pending]: (state) => {
    state.skipVerification.data = null;
    state.skipVerification.loading = true;
    state.skipVerification.error = null;
  },
  [skipVerification.fulfilled]: (state, action) => {
    state.skipVerification.loading = false;
    state.skipVerification.data = action.payload;
    state.skipVerification.error = null;
  },
  [skipVerification.rejected]: (state, action) => {
    state.skipVerification.loading = false;
    state.skipVerification.error = action.payload;
  },
};
